const SITE_URL = 'https://kfx-dev.com';
const DEFAULT_IMAGE_URL = `${SITE_URL}/logo.png`;
const DEFAULT_IMAGE_ALT = 'KFX Development logo';
export const DEFAULT_SITE_DESCRIPTION = 'KFX Development is a small studio of developers with over a decade of experience in development and design. We create what Minecraft deserves!';

function normalizePath(path = '/') {
  const value = String(path || '/').trim();
  if (!value || value === '/') {
    return '/';
  }

  return value.startsWith('/') ? value : `/${value}`;
}

export function absoluteUrl(path = '/') {
  return new URL(normalizePath(path), SITE_URL).toString();
}

function buildRobotsContent({ index = true, follow = true } = {}) {
  return `${index ? 'index' : 'noindex'}, ${follow ? 'follow' : 'nofollow'}`;
}

export function buildSeoMeta({
  title,
  description = DEFAULT_SITE_DESCRIPTION,
  path = '/',
  titleTemplate = '%s - KFX Development',
  image = DEFAULT_IMAGE_URL,
  type = 'website',
  robots = { index: true, follow: true },
  jsonLd = [],
}) {
  const canonical = absoluteUrl(path);
  const graph = [].concat(jsonLd).filter(Boolean);

  return {
    title,
    titleTemplate,
    meta: [
      { vmid: 'description', name: 'description', content: description },
      { vmid: 'robots', name: 'robots', content: buildRobotsContent(robots) },
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { vmid: 'twitter:site', name: 'twitter:site', content: '@kfxdevelopment' },
      { vmid: 'twitter:title', name: 'twitter:title', content: title },
      { vmid: 'twitter:description', name: 'twitter:description', content: description },
      { vmid: 'twitter:image', name: 'twitter:image', content: image },
      { vmid: 'og:locale', property: 'og:locale', content: 'en_US' },
      { vmid: 'og:title', property: 'og:title', content: title },
      { vmid: 'og:description', property: 'og:description', content: description },
      { vmid: 'og:type', property: 'og:type', content: type },
      { vmid: 'og:image', property: 'og:image', content: image },
      { vmid: 'og:image:alt', property: 'og:image:alt', content: DEFAULT_IMAGE_ALT },
      { vmid: 'og:url', property: 'og:url', content: canonical },
      { vmid: 'og:site_name', property: 'og:site_name', content: 'KFX Development' },
    ],
    link: [
      { vmid: 'canonical', rel: 'canonical', href: canonical },
    ],
    script: graph.map((entry, index) => ({
      vmid: `jsonld-${index}`,
      type: 'application/ld+json',
      json: entry,
    })),
  };
}

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'KFX Development',
    url: SITE_URL,
    logo: DEFAULT_IMAGE_URL,
    sameAs: [
      'https://discord.gg/BreAQA99jN',
      'https://builtbybit.com/creators/178050/',
    ],
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'KFX Development',
    url: SITE_URL,
    inLanguage: 'en',
  };
}

export function buildBreadcrumbJsonLd(items = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

export function buildSoftwareJsonLd({
  name,
  description,
  path,
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    applicationCategory: 'DeveloperApplication',
    operatingSystem: 'Minecraft Server',
    url: absoluteUrl(path),
    image: DEFAULT_IMAGE_URL,
    publisher: {
      '@type': 'Organization',
      name: 'KFX Development',
      url: SITE_URL,
    },
  };
}
